module.exports = __webpack_public_path__ + "dingbeauty-build/img/store3_big@1.cea1aef7.jpg";